export const exploreText = {
  filter: 'Filter',
  categories: 'Categories',
  title: 'Explore & enroll in your next tapybl course!',
  noCourses: 'At the moment there are no public courses',
  clearFilter: 'Clear Filter',
};
